import { render, staticRenderFns } from "./TempHomeSearch.vue?vue&type=template&id=223474b3&scoped=true&"
import script from "./TempHomeSearch.vue?vue&type=script&lang=ts&"
export * from "./TempHomeSearch.vue?vue&type=script&lang=ts&"
import style0 from "./TempHomeSearch.vue?vue&type=style&index=0&id=223474b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223474b3",
  null
  
)

export default component.exports